@if (customIconSrc(); as iconSrc) {
  <img [src]="iconSrc" [alt]="name() ?? ''" class="bv-two-factor-provider-icon" />
} @else {
  <auth-two-factor-icon [provider]="provider()" [name]="name()" />
}
